import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ConfigActions, SetAlertsTokenAction } from './actions';
import { MessagesStatusLoadAction } from '../messages-status/actions';

@Injectable()
export class ConfigEffects {
  
  public loadMessages$: Observable<
    MessagesStatusLoadAction
  > = createEffect(()=>this.actions$.pipe(
    ofType(ConfigActions.SetToken),
    filter((action: SetAlertsTokenAction) => !!action.payload),
    map(() => new MessagesStatusLoadAction())
  ));

  constructor(private actions$: Actions) {}
}
